import { useState, useEffect } from 'react';
import { chartjsReady } from '#src/chartjs.ts';

export const useChartjsReady = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    chartjsReady.then(() => {
      if (!cancelled) {
        setReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return ready;
};
